import React from 'react';
import './ClompCoin.css';

// A Clomp Coin: what booster packs are bought with, earned from achievements and from playing the games. The icon
// is the size of the text it sits in.
export function ClompCoin({ className = '' }) {
    return (
        <svg className={`clomp-coin ${className}`} viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="#f5b942" stroke="#b97a12" strokeWidth="1.5" />
            <circle cx="12" cy="12" r="7.8" fill="none" stroke="#fde49a" strokeWidth="1.1" />
            <path d="M14.9 9.5a4 4 0 1 0 0 5" fill="none" stroke="#7a4d08" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
    );
}

// An amount of Clomp Coins, with the icon in front
export function Coins({ amount, className = '' }) {
    return (
        <span className={`clomp-coins ${className}`}>
            <ClompCoin />{amount.toLocaleString()}<span className="sr-only"> Clomp Coins</span>
        </span>
    );
}
